import { render, staticRenderFns } from "./TnC.vue?vue&type=template&id=329d5f78&scoped=true"
import script from "./TnC.vue?vue&type=script&lang=js"
export * from "./TnC.vue?vue&type=script&lang=js"
import style0 from "./TnC.vue?vue&type=style&index=0&id=329d5f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329d5f78",
  null
  
)

export default component.exports